module.exports = __webpack_public_path__ + "static/media/correcoes-3.80120028.png";